// extracted by mini-css-extract-plugin
export default {"SkipIntroButtonWrapper":"SkipIntroButtonWrapper--UOtvF"};